import styled from '@emotion/styled';
import { gutterSizes } from '../base/theme';

export const SearchResultWrapper = styled.ul`
    margin-bottom: ${gutterSizes.xxlarge}
`;
